import { FlightType, PaxType } from '@vueling-ng/vy-cdk-searcher';
import { AVAILABILITY_PROVIDER_NAME } from 'app/services/api-services/availability/models/path-availability.enum';

export const PromotionalText = ['home_component.promos.first', 'home_component.promos.secund'];

export const SearcherConfig = {
  station: {
    defaultCode: 'BCN',
    defaultAvailabilityProvider: AVAILABILITY_PROVIDER_NAME,
    providers: [
      {
        nameProvider: 'SearcherStationsDefaultProvider',
        nameAvailability: AVAILABILITY_PROVIDER_NAME,
        isDefault: true
      }
    ],
    show: true,
    isMultiDestinationsOptions: false
  },
  datepicker: {
    range: {
      startDate: new Date(),
      finalDateOffset: 7,
      monthsRange: 13
    },
    price: {
      enabled: true,
      lowPriceLabel: 'Low Price'
    },
    show: true,
    monthSelector: false,
    oneWay: false
  },
  pax: {
    showAlert: true,
    minDaysForExtraSeatReservation: 3,
    items: [
      {
        paxType: PaxType.Adults,
        value: 1,
        min: 0,
        max: 25,
        includeInInput: true
      },
      {
        paxType: PaxType.Children,
        value: 0,
        maxWhenAdults: 12,
        min: 0,
        max: 6,
        includeInInput: true
      },
      {
        paxType: PaxType.Infants,
        value: 0,
        dependent: [PaxType.Adults],
        min: 0,
        max: 16,
        includeInInput: true
      },
      {
        paxType: PaxType.ExtraSeats,
        value: 0,
        dependent: [PaxType.Adults, PaxType.Children],
        min: 0,
        max: 25,
        includeInInput: false
      }
    ],
    show: true
  },
  search: {
    defaultFlightType: FlightType.RoundTrip,
    recentSearches: {
      deleteOptionEnabled: true,
      maxDestinations: 3,
      maxOrigins: 3
    }
  },
  flightType: {
    show: false,
    defaultType: FlightType.RoundTrip
  },
  flightNumber: {
    show: false
  }
};
